
import MainLayout from "@/components/layout/MainLayout";
import WeatherCard from "@/components/weather/WeatherCard";

const Weather = () => {
  return (
    <MainLayout>
      <div className="travel-container py-12">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2">Weather Forecast</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Check the current weather conditions for your travel destination.
          </p>
        </div>
        
        <div className="max-w-md mx-auto">
          <WeatherCard />
        </div>
        
        <div className="mt-12 max-w-3xl mx-auto">
          <h2 className="text-2xl font-bold mb-4">Weather Insights for Travelers</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-card">
              <h3 className="text-lg font-medium mb-3">Best Time to Visit Popular Destinations</h3>
              <ul className="space-y-2">
                <li className="flex justify-between">
                  <span>Bali, Indonesia</span>
                  <span className="text-travel-blue">April - October</span>
                </li>
                <li className="flex justify-between">
                  <span>Paris, France</span>
                  <span className="text-travel-blue">April - June, September - October</span>
                </li>
                <li className="flex justify-between">
                  <span>Tokyo, Japan</span>
                  <span className="text-travel-blue">March - May, September - November</span>
                </li>
                <li className="flex justify-between">
                  <span>New York City, USA</span>
                  <span className="text-travel-blue">April - June, September - November</span>
                </li>
                <li className="flex justify-between">
                  <span>Cape Town, South Africa</span>
                  <span className="text-travel-blue">October - April</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-card">
              <h3 className="text-lg font-medium mb-3">Packing Tips by Weather</h3>
              <div className="space-y-3">
                <div>
                  <h4 className="font-medium">Hot & Humid</h4>
                  <p className="text-sm text-gray-600">Lightweight, breathable fabrics, hat, sunscreen, insect repellent</p>
                </div>
                <div>
                  <h4 className="font-medium">Hot & Dry</h4>
                  <p className="text-sm text-gray-600">Light layers, hat, sunglasses, sunscreen, water bottle</p>
                </div>
                <div>
                  <h4 className="font-medium">Mild</h4>
                  <p className="text-sm text-gray-600">Mix of short and long sleeves, light jacket, comfortable shoes</p>
                </div>
                <div>
                  <h4 className="font-medium">Cold</h4>
                  <p className="text-sm text-gray-600">Thermal layers, warm jacket, gloves, scarf, hat, waterproof boots</p>
                </div>
                <div>
                  <h4 className="font-medium">Rainy</h4>
                  <p className="text-sm text-gray-600">Waterproof jacket, umbrella, quick-dry clothing, waterproof shoes</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Weather;
